//Token
export const GET_TOKEN_REQUEST = 'GET_TOKEN_REQUEST'
export const GET_TOKEN_SUCCESS = 'GET_TOKEN_SUCCESS'
export const GET_TOKEN_FAIL = 'GET_TOKEN_FAIL'

//Lead form
export const GET_LEAD_FORM_REQUEST = 'GET_LEAD_FORM_REQUEST'
export const GET_LEAD_FORM_SUCCESS = 'GET_LEAD_FORM_SUCCESS'
export const GET_LEAD_FORM_FAIL = 'GET_LEAD_FORM_FAIL'

export const LEAD_FORM_SUBMIT_REQUEST = 'LEAD_FORM_SUBMIT_REQUEST'
export const LEAD_FORM_SUBMIT_SUCCESS = 'LEAD_FORM_SUBMIT_SUCCESS'
export const LEAD_FORM_SUBMIT_FAIL = 'LEAD_FORM_SUBMIT_FAIL'

export const PUBLISH_REQUEST = 'PUBLISH_REQUEST'
export const PUBLISH_SUCCESS = 'PUBLISH_SUCCESS'
export const PUBLISH_FAIL = 'PUBLISH_FAIL'

// Privacy Policy
export const GET_PRIVACY_POLICY_REQUEST = 'GET_PRIVACY_POLICY_REQUEST'
export const GET_PRIVACY_POLICY_SUCCESS = 'GET_PRIVACY_POLICY_SUCCESS'
export const GET_PRIVACY_POLICY_FAIL = 'GET_PRIVACY_POLICY_FAIL'

// Cookie Policy
export const GET_COOKIE_POLICY_REQUEST = 'GET_COOKIE_POLICY_REQUEST'
export const GET_COOKIE_POLICY_SUCCESS = 'GET_COOKIE_POLICY_SUCCESS'
export const GET_COOKIE_POLICY_FAIL = 'GET_COOKIE_POLICY_FAIL'

//Survey
export const GET_SURVEY_FORM_REQUEST = 'GET_SURVEY_FORM_REQUEST'
export const GET_SURVEY_FORM_SUCCESS = 'GET_SURVEY_FORM_SUCCESS'
export const GET_SURVEY_FORM_FAIL = 'GET_SURVEY_FORM_FAIL'

export const GET_SURVEY_SECTIONS_REQUEST = 'GET_SURVEY_SECTIONS_REQUEST'
export const GET_SURVEY_SECTIONS_SUCCESS = 'GET_SURVEY_SECTIONS_SUCCESS'
export const GET_SURVEY_SECTIONS_FAIL = 'GET_SURVEY_SECTIONS_FAIL'

export const SUBMIT_SURVEY_FORM_REQUEST = 'SUBMIT_SURVEY_FORM_REQUEST'
export const SUBMIT_SURVEY_FORM_SUCCESS = 'SUBMIT_SURVEY_FORM_SUCCESS'
export const SUBMIT_SURVEY_FORM_FAIL = 'SUBMIT_SURVEY_FORM_FAIL'

export const GET_SURVEY_RESULT_REQUEST = 'GET_SURVEY_RESULT_REQUEST'
export const GET_SURVEY_RESULT_SUCCESS = 'GET_SURVEY_RESULT_SUCCESS'
export const GET_SURVEY_RESULT_FAIL = 'GET_SURVEY_RESULT_FAIL'

export const GET_SURVEY_REPORT_REQUEST = 'GET_SURVEY_REPORT_REQUEST'
export const GET_SURVEY_REPORT_SUCCESS = 'GET_SURVEY_REPORT_SUCCESS'
export const GET_SURVEY_REPORT_FAIL = 'GET_SURVEY_REPORT_FAIL'


export const GET_SURVEY_DETAIL_REQUEST = 'GET_SURVEY_DETAIL_REQUEST'
export const GET_SURVEY_DETAIL_SUCCESS = 'GET_SURVEY_DETAIL_SUCCESS'
export const GET_SURVEY_DETAIL_FAIL = 'GET_SURVEY_DETAIL_FAIL'

//Survey fields data 
export const CLEAR_SECTION_FIELDS = 'CLEAR_SECTION_FIELDS'
export const CLEAR_ALL_FIELDS = 'CLEAR_ALL_FIELDS'
export const SET_SECTION_FIELDS = 'SET_SECTION_FIELDS'

//Report config
export const GET_DEFAULT_REPORT_REQUEST = 'GET_DEFAULT_REPORT_REQUEST'
export const GET_DEFAULT_REPORT_SUCCESS = 'GET_DEFAULT_REPORT_SUCCESS'
export const GET_DEFAULT_REPORT_FAIL = 'GET_DEFAULT_REPORT_FAIL'

export const IS_FORM_SUBMITTED_TO_ELOQUA_REQUEST = 'IS_FORM_SUBMITTED_TO_ELOQUA_REQUEST'
export const IS_FORM_SUBMITTED_TO_ELOQUA_SUCEESS = 'IS_FORM_SUBMITTED_TO_ELOQUA_SUCEESS'
export const IS_FORM_SUBMITTED_TO_ELOQUA_FAIL = 'IS_FORM_SUBMITTED_TO_ELOQUA_FAIL'


export const GET_STAGE_REQUEST = 'GET_STAGE_REQUEST'
export const GET_STAGE_SUCCESS = 'GET_STAGE_SUCCESS'
export const GET_STAGE_FAIL = 'GET_STAGE_FAIL'

export const GET_COUNTRY_CODES_REQUEST = "GET_COUNTRY_CODES_REQUEST";
export const GET_COUNTRY_CODES_SUCCESS = "GET_COUNTRY_CODES_SUCCESS";
export const GET_COUNTRY_CODES_FAIL = "GET_COUNTRY_CODES_FAIL"


export const GET_ACTIVE_WEBHOOKS_REQUEST = "GET_ACTIVE_WEBHOOKS_REQUEST";
export const GET_ACTIVE_WEBHOOKS_SUCCESS = "GET_ACTIVE_WEBHOOKS_SUCCESS";
export const GET_ACTIVE_WEBHOOKS_FAIL = "GET_ACTIVE_WEBHOOKS_FAIL";

export const TRIGGER_WEBHOOK_SUCCESS = "TRIGGER_WEBHOOK_SUCCESS";
export const TRIGGER_WEBHOOK_FAIL = "TRIGGER_WEBHOOK_FAIL";

// Group Languages
export const GET_GROUP_LANGUAGES_REQUEST = "GET_GROUP_LANGUAGES_REQUEST";
export const GET_GROUP_LANGUAGES_SUCCESS = "GET_GROUP_LANGUAGES_SUCCESS";
export const GET_GROUP_LANGUAGES_FAIL = "GET_GROUP_LANGUAGES_FAIL";

